exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald&display=swap);", ""]);
exports.push([module.id, "@import url(https://use.fontawesome.com/releases/v5.8.2/css/all.css);", ""]);

// module
exports.push([module.id, "#app{margin-top:-10px;font-size:14px}#app h2{font-size:21px}#app hr{margin:unset;border-color:unset}", ""]);

// exports
